'use strict';

angular.module('imagetrend.components')
    .controller('ImportCliniciansModalController', ['$scope', '$uibModalInstance', 'Upload', 'Documents', function ($scope, $uibModalInstance, Upload, Documents) {

        $scope.vm = {
            file: null,
            file_content: null,
            file_name: null
        }
        $scope.uploading = false;
        $scope.working = false;
        $scope.uploaded_document_id = null;
        $scope.uploaded_document_code = null;
        $scope.uploadMessage = null;
        $scope.errorMessage = null;

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            $scope.uploaded_document_id = null;
            $scope.uploaded_document_code = null;
            $scope.errorMessage = null;
            if (file == null) {
                $scope.working = false;
                $scope.uploading = false;
                return;
            }
            $scope.working = true;

            function base64Fallback() {
                Upload.base64DataUrl(file).then(function (content) {
                    $scope.vm.file_content = content;
                    $scope.working = false;
                    $scope.uploading = false;
                });
            }

            Documents.storageAvailable().then(function (storageResponse) {
                if (storageResponse.documentStorageAvailable) {
                    $scope.uploading = true;
                    $scope.uploadMessage = 'Uploading file...';
                    Documents.storageUpload(null, {
                        file: file,
                        name: file.name,
                        description: '',
                        document_type_id: null
                    }, function (progress) {
                        $scope.uploadMessage = 'Upload progress: ' + progress.percent + '%';
                    }).then(function (response) {
                        $scope.uploaded_document_id = response.data.id;
                        $scope.uploaded_document_code = response.data.code;
                        $scope.vm.file_name = response.data.file_name;
                        $scope.uploadMessage = 'Upload complete';
                        $scope.working = false;
                        $scope.uploading = false;
                    }).catch(function (error) {
                        $scope.uploaded_document_id = null;
                        $scope.working = false;
                        $scope.uploading = false;
                        $scope.errorMessage = 'Upload failed: ' + ((error && error.data && error.data.Message) || 'Please try again.');
                    });
                } else {
                    base64Fallback();
                }
            }).catch(function () {
                base64Fallback();
            });
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function () {
            if ($scope.vm.file != null && $scope.uploaded_document_id != null) {
                $uibModalInstance.close({
                    document_id: $scope.uploaded_document_id,
                    document_code: $scope.uploaded_document_code,
                    file_name: $scope.vm.file_name,
                    is_new_upload: true
                });
            }
            else if ($scope.vm.file != null && $scope.vm.file_content != null) {
                $uibModalInstance.close({
                    file_name: $scope.vm.file.name,
                    file_content: $scope.vm.file_content
                });
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;